import i18n from '@dms/i18n';

/**
 * Kanban column definitions with their keys and labels
 * This is the single source of truth for all kanban columns
 */
export const KANBAN_COLUMNS = [
  {key: 'newInterest', label: i18n.t('page.opportunitiesKanban.newInterest')},
  {key: 'activeInterest', label: i18n.t('page.opportunitiesKanban.activeInterest')},
  {key: 'offer', label: i18n.t('page.opportunitiesKanban.offer')},
  {key: 'contract', label: i18n.t('page.opportunitiesKanban.contract')},
  {key: 'paymentRequest', label: i18n.t('page.opportunitiesKanban.paymentRequest')},
  {key: 'paymentReceived', label: i18n.t('page.opportunitiesKanban.paymentReceived')},
  {key: 'invoice', label: i18n.t('page.opportunitiesKanban.invoice')},
  {key: 'paid', label: i18n.t('page.opportunitiesKanban.paid')},
] as const;

/**
 * Column keys extracted from KANBAN_COLUMNS for easy access
 */
export const KANBAN_COLUMN_KEYS = {
  NEW_INTEREST: KANBAN_COLUMNS[0].key,
  ACTIVE_INTEREST: KANBAN_COLUMNS[1].key,
  OFFER: KANBAN_COLUMNS[2].key,
  CONTRACT: KANBAN_COLUMNS[3].key,
  PAYMENT_REQUEST: KANBAN_COLUMNS[4].key,
  PAYMENT_RECEIVED: KANBAN_COLUMNS[5].key,
  INVOICE: KANBAN_COLUMNS[6].key,
  PAID: KANBAN_COLUMNS[7].key,
} as const;

/**
 * Automatically generated mapping from column keys to indices
 */
export const KANBAN_COLUMN_VALUE_TO_INDEX: Record<string, number> = KANBAN_COLUMNS.reduce(
  (mapping, column, index) => {
    mapping[column.key] = index;
    return mapping;
  },
  {} as Record<string, number>
);

/**
 * Type helper for column key values
 */
export type KanbanColumnKey = (typeof KANBAN_COLUMNS)[number]['key'];
